import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Swipe from 'react-easy-swipe';
import Thumbnail from '../Lightbox/Thumbnail';
import StoryContent from './StoryContent';
import LoadingSpinner from '../utility/LoadingSpinner';
import iconLeft from '../../images/icons/icon_48_leftchev.png';
import iconRight from '../../images/icons/icon_48_rightchev.png';
import { withTranslation } from 'react-i18next';

import {
  fetchStories,
  setActiveStory,
} from '../../actions/stories';

import {
  clearApiError,
} from '../../actions/api';

import {
  formatDate,
} from '../../js/utility';

class Stories extends Component {
  constructor(props) {
    super(props);
    this.initData = this.initData.bind(this);
    this.setStoryInterval = this.setStoryInterval.bind(this);
    this.handleStoryClick = this.handleStoryClick.bind(this);
    this.changeStory = this.changeStory.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.clearApiError();
    const { hasFetched } = this.props;
    if(!hasFetched) {
      this.initData();
    }
  }

  setStoryInterval() {
    this.timer = setInterval(() => {
      const { stories, currentStory, setActiveStory } = this.props;
      let currIndex = stories.findIndex((story) => story.id === currentStory);

      if(currIndex + 1 >= stories.length) {
        setActiveStory(stories[0].id);
      } else {
        setActiveStory(stories[currIndex + 1].id);
      }
    }, this.props.interval);
  }

  handleStoryClick(id) {
    clearInterval(this.timer);
    this.props.setActiveStory(id);
  }

  changeStory(amount) {
    const { stories, currentStory, setActiveStory } = this.props;
    const maxStories = stories.length;
    const currIndex = stories.findIndex((story) => story.id === currentStory);
    clearInterval(this.timer);
    if(currIndex >= maxStories - 1 && amount > 0) {
      setActiveStory(stories[0].id);
    } else if (currIndex === 0 && amount < 0) {
      setActiveStory(stories[maxStories - 1].id);
    } else {
      let newId = stories[currIndex + amount].id;
      setActiveStory(newId);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.timer);
  }

  async initData() {
    const { fetchStories, setActiveStory } = this.props;
    await fetchStories();
    const { stories } = this.props;
    if(this._isMounted && stories && stories.length > 0) {
      setActiveStory(stories[0].id);
      // this.setStoryInterval();
    }
  }

  render() {
    const { loading, error, stories, currentStory, t } = this.props;
    if(loading) {
      return (
        <LoadingSpinner />
      );
    }
    if(error || !stories || stories.length < 1) {
      return null;
    }
    return (
      <section
        className="fe-home-stories"
      >
        <Swipe
          onSwipeRight={() => this.changeStory(-1)}
          onSwipeLeft={() => this.changeStory(1)}
          tolerance={100}
        >
          <div className='grey-div'>
            <div className="container">
              <h2 className="fe-stories-heading">{t('home:realStories')}</h2>
              <div className="row justify-content-lg-center">
                <div className="fe-stories-btn left"
                  onClick={() => this.changeStory(-1)}
                >
                  <img src={iconLeft} alt=""/>
                </div>
                <div className="fe-stories-btn right"
                  onClick={() => this.changeStory(1)}
                >
                  <img src={iconRight} alt=""/>
                </div>
                <div className="col-lg-10">
                  {/* <h2 className="fe-stories-heading">{t('home:realStories')}</h2> */}
                  <div className="fe-stories-container">
                    {stories.map((story) => {
                      let classStr = '';
                      if(story.id === currentStory) {
                        classStr = 'active';
                      } else if(story.id < currentStory) {
                        classStr = 'prev';
                      } else {
                        classStr = 'next';
                      }
                      return (
                        <div key={story.id} className={`fe-stories-item ${classStr}`}>
                          <div className="fe-stories-profile-desktop">
                            <div className="fe-stories-profile-img">
                              <img src={story.avatar_img} alt=""/>
                            </div>
                          </div>
                          <StoryContent overlayText={t('home:readMore')}>
                            <div className="fe-stories-profile">
                              <div className="fe-stories-profile-img">
                                <img src={story.avatar_img} alt=""/>
                              </div>
                              <div className="fe-stories-profile-info">
                                <div className="fe-stories-profile-name">{story.name}</div>
                                <div className="fe-stories-profile-date">{formatDate(story.trip_date)}</div>
                              </div>
                            </div>
                            <h3 className="fe-stories-trip-title">
                              <Link to={`/trips/${story.trip_slug}`}>{story.trip_title}</Link>
                            </h3>
                            <div className="fe-stories-review">
                              <p>{story.story}</p>
                            </div>
                            {story.gallery.length > 0 ?
                              <div className="fe-stories-gallery">
                                {story.gallery.map((photo, idx) => (
                                  <div key={idx} className="fe-stories-gallery-thumb">
                                    <div className="fe-u-thumb-4by3 fe-rounded">
                                      <Thumbnail
                                        id={idx}
                                        galleryId={`stories-gallery-${story.id}`}
                                        fullSrc={photo.img_url}
                                        src={photo.thumbnail_url}
                                        alt=""
                                        isFinalImage={idx + 1 >= story.gallery.length}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div> : null}
                          </StoryContent>
                        </div>
                      );
                    })}
                  </div>
                  <div className="fe-stories-indicators">
                    {stories.map((story) => {
                      return (
                        <span
                          key={story.id}
                          onClick={() => this.handleStoryClick(story.id)}
                          className={`fe-story-indicator ${currentStory === story.id ? 'active' : ''}`}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Swipe>
      </section>
    );
  }
}

Stories.propTypes = {
  stories: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  fetchStories: PropTypes.func.isRequired,
  setActiveStory: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  currentStory: PropTypes.number.isRequired,
  interval: PropTypes.number.isRequired,
  hasFetched: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

Stories.defaultProps = {
  interval: 2500,
};

const mapStateToProps = ({ storiesState }) => ({
  stories: storiesState.stories,
  currentStory: storiesState.currentStory,
  loading: storiesState.loading,
  hasFetched: storiesState.hasFetched,
  error: storiesState.error,
});

const mapDispatchToProps = {
  fetchStories,
  clearApiError,
  setActiveStory,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Stories));
